/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsDataset,
  AnalyticsDataset$inboundSchema,
} from "./analyticsdataset.js";

export type AnalyticsDescribeResult = {
  /**
   * The datasets the caller can read
   */
  datasets: Array<AnalyticsDataset>;
  /**
   * Names of the datasets the caller cannot read, such as one only organization administrators can read, so a saved widget over one can say why it shows nothing rather than reading as broken
   */
  restrictedDatasets?: Array<string> | undefined;
};

/** @internal */
export const AnalyticsDescribeResult$inboundSchema: z.ZodMiniType<
  AnalyticsDescribeResult,
  unknown
> = z.pipe(
  z.object({
    datasets: z.array(AnalyticsDataset$inboundSchema),
    restricted_datasets: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "restricted_datasets": "restrictedDatasets",
    });
  }),
);

export function analyticsDescribeResultFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDescribeResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDescribeResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDescribeResult' from JSON`,
  );
}
